import React from 'react';

import { TransferUserInfoType } from '../types';
import UserInfoTransferTable from '../UserInfoTransferTable';
import Modal from '../../../../../../../components/Modal';
import { columns } from './columns';
import './UserInfoTransferConfirmModal.scss';

interface IUserInfoTransferConfirmModalProps {
  onOk: () => void;
  onClose: () => void;
  info: TransferUserInfoType;
}

const UserInfoTransferConfirmModal = (props: IUserInfoTransferConfirmModalProps): JSX.Element => {
  const { onOk, onClose, info } = props;
  return (
    <Modal
      title="유저 계정 변경"
      isOpen={true}
      width={1200}
      isFooter={true}
      onOk={onOk}
      onClose={onClose}
      okText="완료"
      maskClosable={false}
    >
      <div className="user-info-transfer-confirm-modal-title">
        <p>
          유지할 회원의 유저 계정이 다음과 같이 변경됩니다. 완료 버튼을 누르면 <b>변경사항</b>이 적용됩니다.
        </p>
      </div>
      <UserInfoTransferTable columns={columns(info)} />
    </Modal>
  );
};

export default UserInfoTransferConfirmModal;
